import { ConfigurationService } from './configuration.service';

export class FeatureFlagService {
  public static get enableMicromobilitySearch(): boolean {
    return ConfigurationService.get('featureflags.travelplanner.enablemicromobilitysearch') === 'True';
  }

  public static get enableTrafficInformationMessagesVersionTwo(): boolean {
    return ConfigurationService.get('featureflags.trafficinformation.messages.versiontwo') === 'True';
  }
}
